// @flow
import { combineReducers } from 'redux';

import * as types from '../types/gates';
import * as common from './common';
import type { ERROR_TYPE } from '../types/common';
import type { GATE_TYPE } from '../types/gates';

export type GatesState = {
  byId: { [number]: GATE_TYPE },
  order: Array<number>,
  isFetching: boolean,
  errors: { [number]: ERROR_TYPE },
  current: number
};

const byId = common.byId({
  added: [types.GATES_FETCH_SUCCESS, types.GATE_CREATE_SUCCESS],
  fetched: [types.GATES_FETCH_SUCCESS],
  removed: [types.REMOVE_GATE_SUCCEED],
});

const errors = common.errors({
  populate: [types.GATES_FETCH_FAILED],
  clear: [types.GATES_FETCH_FAILED],
});

const isFetching = common.isFetching({
  started: [types.GATES_FETCH_STARTED],
  succeed: [types.GATES_FETCH_SUCCESS],
  failed: [types.GATES_FETCH_FAILED],
});

const order = common.order({
  fetched: [types.GATES_FETCH_SUCCESS],
  added: [types.GATES_FETCH_SUCCESS, types.GATE_CREATE_SUCCESS],
  removed: [types.REMOVE_GATE_SUCCEED],
});

const current = common.mux({
  selected: [types.GATE_SELECTED],
  default: -1,
});

const gate = combineReducers({
  byId,
  errors,
  isFetching,
  order,
  current,
});

export default gate;

export const getGate = (state: GatesState, id: number): GATE_TYPE => state.byId[id];
export const getGates = (state: GatesState): Array<GATE_TYPE> => state.order.map(
  id => getGate(state, id),
);
export const areGatesFetching = (state: GatesState): boolean => state.isFetching;
export const getGatesChangeStopAvailable = (state: GatesState): Array<GATE_TYPE> => {
  const filteredIds = state.order.filter(elm => state.byId[elm].allow_change_requests);
  return filteredIds.map(elm => state.byId[elm]);
};
export const getCurrentGate = (state: GatesState): GATE_TYPE => getGate(state, state.current);



// WEBPACK FOOTER //
// ./src/scripts/reducers/gates.js